var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 4,
    fill: "#FF6161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4142 16L21.364 11.0502L19.9497 9.63603L15 14.5858L10.0503 9.63603L8.63604 11.0502L13.5858 16L8.63604 20.9497L10.0503 22.3639L15 17.4142L19.9497 22.3639L21.364 20.9497L16.4142 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.dc0dc4ca58cb0bc314bd6f3d086ac33c.svg";
export { ForwardRef as ReactComponent };